// extracted by mini-css-extract-plugin
export default {"root":"TherapistLanding_root__Ma9bM","slider":"TherapistLanding_slider__3gwg-"};